<template lang="pug">
.flex.flex-col
  .shortcutWrapper.fixed.inset-0.flex.justify-center.z-30(v-if="showShortcut", class="bg-black/70", @click="showShortcut = false")
    .shortcutInner.absolute.top-8(class="portrait:top-14")
      Shortcut
  header.header-layout.flex.items-start.text-xs.text-primary-text(:class="['portrait:text-base portrait:flex-wrap portrait:h-auto portrait:justify-between px-2 portrait:mt-1', { 'navbar-exist': (navbarSettings || []).length > 0 }]")
    .flex(class="portrait:w-full portrait:justify-between")
      .logo.cursor-pointer(class="portrait:xs:my-2 landscape:mt-2", @click="clickLogo")
        img.w-full.h-full.object-contain(:src="logoUrl")
      .flex.flex-1.justify-end(class="landscape:!hidden")
        button#layoutConfig.self-center.relative(v-if="hasShortcutBlock", :class="['portrait:z-30', { showShortcut: showShortcut }]", @click="openShortcut")
          img(:src="getFrontCdnUrl('images/common/layout_btn_menu_{locale}_normal.png')")
        .account-layout.flex.self-center.w-auto(class="xs:mx-2 xs:gap-x-2 portrait:z-20")
          button.h-full(v-if="hasRegister", @click="showModalFunc('ModalPanelSignUp')")
            img.h-full(:src="getFrontCdnUrl('images/login/login_btn_signup_{locale}_normal.png')")
          button.h-full(v-else, @click="showModalFunc('ModalPanelLogin')")
            img.h-full(:src="getFrontCdnUrl('images/login/login_btn_login_{locale}_normal.png')")
    .flex.flex-col.flex-1.w-0.h-auto(class="portrait:h-auto portrait:w-full")
      .flex.w-full.border-s.border-e.border-b.border-header-border.bg-linear-to-b.from-header-from.to-header-to.mx-auto.h-auto(class="xs:flex-1 landscape:rounded-b-[15.5px] lg:landscape:py-[0.32rem] lg:landscape:rounded-b-3xl", :class="['header-wrapper portrait:mt-2 portrait:w-full portrait:rounded-3xl', { 'landscape:z-30': !showShortcut }, { 'marquee-exist border-b-0 lg:landscape:rounded-none': announcements.length > 0 }]")
        .flex-1.grid.grid-flow-col.auto-cols-auto.header-balance-wrapper(class="gap-x-1.5 xs:gap-x-2")
          #balance.relative.flex.justify-between.items-center.gap-x-1
            BaseWalletButton(:amount="getFormatted(0, 'FORCE_FLOAT')", mode="cash", :disabled="true", data-location="coin", data-icon="Coin")
          template(v-if="!hideActivityWallet")
            #free.relative.flex.justify-between.items-center
              BaseWalletButton(:amount="getFormatted(0, 'FORCE_FLOAT')", mode="activity", :disabled="true", data-location="lobby", data-icon="Free")
          template(v-if="diamondShopEnable")
            #point.relative.flex.justify-between.items-center
              BaseWalletButton(:amount="getFormatted(0, 'POINTS')", mode="point", :disabled="true", data-location="lobby", data-icon="Diamond")
        button#layoutConfig.flex.items-center.self-center.ms-2(v-if="hasShortcutBlock", :class="['portrait:hidden', { showShortcut: showShortcut }]", @click="openShortcut")
          img(v-if="showShortcut", :src="getFrontCdnUrl('images/common/layout_btn_close_{locale}_normal.png')")
          img(v-else, :src="getFrontCdnUrl('images/common/layout_btn_menu_{locale}_normal.png')")
        .w-fit.flex.self-center(class="portrait:!hidden")
          .account-layout.flex.self-center.w-auto(class="lg:mx-2 lg:gap-x-2")
            button.w-21(@click="showModalFunc('ModalPanelLogin')")
              img(:src="getFrontCdnUrl('images/login/login_btn_login_{locale}_normal.png')")
            button.w-21(v-if="hasRegister", @click="showModalFunc('ModalPanelSignUp')")
              img(:src="getFrontCdnUrl('images/login/login_btn_signup_{locale}_normal.png')")
      Marquee.display-with-device(v-if="(announcements || []).length > 0", :source="announcements")
      .mt-2(v-if="(navbarSettings || []).length > 0")
        SideSub(:menuItemStack="menuItemStack")
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useMainStore } from '@/stores/main'
import { useFormat } from '@/composables/core/useFormat'
import Shortcut from '@/components/Shortcut.vue'
import BaseWalletButton from '@/components/base/WalletButton.vue'
import Marquee from '@/components/Marquee.vue'
import SideSub from '@/components/SideSub.vue'
import { useLayout } from '@/composables/core/useLayout'

defineOptions({
  name: 'GuestHeader',
})

const props = defineProps({
  menuItemStack: Array,
  menuList: Array,
})

const emit = defineEmits(['clickLogo'])

const config = useRuntimeConfig()
const { navbarSettings } = useActivity('header')
const { $SoundControl } = useNuxtApp()
const { getBackCdnUrl, getFrontCdnUrl } = useCdnAssets()
const mainStore = useMainStore()
const { announcementList } = useCommon()
const { diamondShopEnable, registerMethods } = useSite()
const { quickLayout } = useLayout()
const { getFormatted } = useFormat()

const { setModal } = mainStore

const clickEvent = ref(false)
const showShortcut = ref(false)
const logoUrl = ref(null)

const hideActivityWallet = computed(() => {
  return config.public.hideActivityWallet ? JSON.parse(config.public.hideActivityWallet) : false
})

const hasShortcutBlock = computed(() => {
  return quickLayout.value?.length > 0
})

const hasRegister = computed(() => {
  return Object.keys(registerMethods.value || {}).length
})

const announcements = computed(() => {
  return (announcementList.value || [])
    .filter((item) => item.displayMode === 'ONLY_MARQUEE' || item.displayMode === 'BOTH')
    .map((a) => {
      return {
        title: a.title,
        content: a.content,
        id: a.subId,
      }
    })
})

const showModalFunc = (name) => {
  if (!clickEvent.value) {
    clickEvent.value = true
    $SoundControl.sound.play('click')
    setModal(name)
    clickEvent.value = false
  }
}

const openShortcut = () => {
  showShortcut.value = !showShortcut.value
}

const clickLogo = () => {
  emit('clickLogo')
}

onMounted(() => {
  logoUrl.value = getBackCdnUrl('icon/logo.png')
})

defineExpose({ getFormatted })
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";

header {
  padding-inline-start: calc(env(safe-area-inset-left) + 0.5rem);
  padding-inline-end: calc(env(safe-area-inset-right) + 0.5rem);
}

@media (orientation: portrait) {
  header {
    padding-top: env(safe-area-inset-top);
  }
}

#point:disabled,
#retain:disabled {
  opacity: 0.5;
}

.logo {
  width: 6.875rem;
  z-index: 11;
}

@media (min-width: 1024px) and (orientation: landscape) {
  .logo {
    display: none;
  }
}

.shortcutWrapper .shortcutInner {
  inset-inline-end: calc(env(safe-area-inset-right) + 1rem);
}

@media screen and (min-width: 926px) {
  .shortcutWrapper .shortcutInner {
    inset-inline-end: calc(env(safe-area-inset-right) + 5rem);
  }
}

@media screen and (orientation: portrait) {
  .shortcutWrapper .shortcutInner {
    inset-inline-end: auto;
  }
}

#layoutConfig {
  height: 2.2rem;
  aspect-ratio: 65/27;
}

#layoutConfig.showShortcut {
  z-index: 40;
}

@media screen and (orientation: landscape) and (min-width: 1024px) {
  #layoutConfig {
    aspect-ratio: 12/5;
  }
}

@media screen and (orientation: portrait) {
  #layoutConfig {
    height: 2.75rem;
  }
}

@media screen and (orientation: portrait) and (min-width: 500px) {
  #layoutConfig {
    height: 2.75rem;
  }
}

.account-layout {
  height: 2.2rem !important;
}

@media screen and (orientation: portrait) {
  .account-layout {
    height: 2.25rem !important;
  }
}

@media screen and (orientation: portrait) and (min-width: 500px) {
  .account-layout {
    height: 2.75rem !important;
  }
}

.header-wrapper {
  @apply xs:flex-1;
  padding: 2px 4px;
}

@media screen and (orientation: landscape) {
  .header-wrapper {
    @apply rounded-b-[15.5px];
  }
}

@media screen and (orientation: landscape) and (min-width: 1024px) {
  .header-wrapper {
    @apply py-[0.32rem] rounded-b-3xl;
  }

  .header-wrapper.marquee-exist {
    @apply rounded-none;
  }
}

.header-balance-wrapper {
  @apply gap-x-1.5 xs:gap-x-2;
}

.header-layout {
  height: fit-content;
}

.display-with-device {
  display: none;
}

@media screen and (min-width: 1024px) and (orientation: landscape) {
  .display-with-device {
    display: flex;
    z-index: 29;
  }
}
</style>
